async function adminRequest<T>(
  username: string,
  password: string,
  path: string,
): Promise<{ data: T }> {
  const response = await fetch(`/api/admin${path}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Basic " + btoa(`${username}:${password}`),
    },
  });
  if (!response.ok) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }
  const data = (await response.json()) as T;
  return { data };
}

export interface BuilderStat {
  user_id: string;
  email: string;
  company_name: string | null;
  survey_count: number;
}

export interface BuilderStatsResponse {
  week: BuilderStat[];
  month: BuilderStat[];
  all_time: BuilderStat[];
}

export interface DayCount {
  date: string;
  count: number;
}

export interface OverviewResponse {
  total_users: number;
  homeowners: number;
  builders: number;
  total_surveys: number;
  surveys_last_7_days: number;
  surveys_last_30_days: number;
  active_subscriptions: number;
  completed_orders: number;
  surveys_per_day: DayCount[];
  registrations_per_day: DayCount[];
}

export async function getBuilderStats(
  username: string,
  password: string,
): Promise<BuilderStatsResponse> {
  const { data } = await adminRequest<BuilderStatsResponse>(username, password, "/stats/builders");
  return data;
}

export async function getOverview(
  username: string,
  password: string,
): Promise<OverviewResponse> {
  const { data } = await adminRequest<OverviewResponse>(username, password, "/stats/overview");
  return data;
}
